import styled from '@emotion/styled';
import { StyledResetButton } from '~/shared/styles/Button';
import { breakpoints } from '~/theme';

export const SearchText = styled.search(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderRadius: 2,
    width: '100%',
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.grey50}`,
    height: theme.space[6],
    overflow: 'hidden',
}));

export const Input = styled.input(({ theme }) => ({
    background: 'transparent',
    minWidth: 0,
    height: theme.space[6],
    inset: 0,
    border: 'none',
    outline: 'none',
    transition: 'width 0.2s ease-in-out',
    flex: '1 1',
    placeholder: 'auto',
    textOverflow: 'ellipsis',

    '::placeholder': {
        fontFamily: theme.fonts.body,
    },
    ':is(:focus, :active)': {
        '::placeholder': {
            color: 'transparent',
        },
    },
}));

export const SearchButton = styled(StyledResetButton)(({ theme }) => ({
    width: theme.space[6],
    height: theme.space[6],
    display: 'grid',
    alignItems: 'center',
    justifyItems: 'center',
    backgroundColor: theme.colors.white,
    color: theme.colors.grey50,
    border: 0,
    cursor: 'auto',

    svg: {
        width: 25,
        height: 25,
        transition: 'transform 0.2s ease-in-out',
    },
}));

export const ClearButton = styled(StyledResetButton)(({ theme }) => ({
    zIndex: theme.zIndices.searchButtons,
    opacity: 1,
    transition: '0.1s ease-in-out',
    transitionProperty: 'opacity, background-color',
    width: theme.space[6],
    height: theme.space[6],
    display: 'grid',
    alignItems: 'center',
    justifyItems: 'center',
    borderRadius: 2,

    '&[aria-hidden="true"]': {
        display: 'none',
    },

    ':is(:hover, :focus, :active)': {
        backgroundColor: theme.colors.grey30,
    },

    svg: {
        width: theme.space[4],
        height: theme.space[4],
    },
}));

export const CloseButton = styled(StyledResetButton)(({ theme }) => ({
    position: 'absolute',
    top: 0,
    right: `-${theme.space[6]}`,
    zIndex: theme.zIndices.searchButtons,
    transition: '200ms ease',
    transitionProperty: 'opacity, color',
    width: theme.space[6],
    height: theme.space[6],
    alignContent: 'center',
    justifyContent: 'center',
    fontSize: theme.fontSizes.beetle,
    display: 'none',

    [breakpoints.md]: {
        display: 'grid',
    },

    [breakpoints.sm]: {
        display: 'grid',
        '&[aria-hidden="true"]': {
            display: 'none',
        },
    },

    ':is(:hover, :focus, :active)': {
        color: theme.colors.brandBlue,
    },

    svg: {
        width: theme.space[4],
        height: theme.space[4],
    },
}));
